import React, { createContext, useContext } from 'react';
import { useActorRef, useSelector } from '@xstate/react';
import { ActorRefFrom } from 'xstate';
import planSelectMachine from './plan-select-machine';
import { CurrentPlan, PaymentMethod, Plan } from '../types';

export const PaymentDetailsContext = createContext({} as ActorRefFrom<typeof planSelectMachine>);

const PlanSelectContext = createContext({} as ActorRefFrom<typeof planSelectMachine>);

export const usePlanSelect = () => useContext(PlanSelectContext);

export const usePaymentDetails = () => {
  const planSelectInterpreter = usePlanSelect();
  return useSelector(planSelectInterpreter, (state) => state.context.paymentDetailsRef);
};

interface ProviderProps {
  currentPlan: CurrentPlan;
  defaultPaymentMethod?: PaymentMethod;
  minConversionLicenses: number;
  plans: Plan[];
  children?: any;
}

export function PlanSelectProvider({
  currentPlan,
  defaultPaymentMethod,
  minConversionLicenses,
  plans,
  children,
}: ProviderProps) {
  const machine = planSelectMachine.provide({
    // Initial context is set here for v5 compatibility
  });

  const service = useActorRef(machine, {
    input: {
      currentPlan,
      defaultPaymentMethod: defaultPaymentMethod || null,
      minConversionLicenses,
      plans,
      toastMessage: '',
      toastSeverity: '',
      errorMessage: '',
    },
  });
  return <PlanSelectContext.Provider value={service}>{children}</PlanSelectContext.Provider>;
}
